'use client';

import { NyttFärgTema } from 'src/theme/NyttFärgtema';

import type { KortProps } from '../kort-katalog';
import DomainCard from '../components/domain-card';

// ----------------------------------------------------------------------

export default function StädningKort(_props: KortProps) {
    return (
        <DomainCard
            title="Städning"
            icon="solar:home-smile-bold"
            theme={NyttFärgTema.Kombinationer[8]}
            emptyMessage="Planera och fördela föräldrarnas städansvar. Här kommer scheman och bocka-av-listor att visas."
        />
    );
}
